import { ImageLibrarySearchResult } from '@/types';
import ImageLibraryResultImage from './ImageLibraryResultImage';
import { memo } from 'react';

type ImageLibraryResultGridColumnType = {
  imageList: ImageLibrarySearchResult[];
  onSelectImage: (imageLibrary: ImageLibrarySearchResult) => void;
  onImageLoad: (e: React.SyntheticEvent<HTMLImageElement>, index: number) => void;
  selectedIds: number[];
  showSaveToScrapbook?: boolean;
  showDownloadBtn?: boolean;
};

const ImageLibraryResultGridColumn = (data: ImageLibraryResultGridColumnType) => {
  const { imageList, onSelectImage, onImageLoad, selectedIds, showSaveToScrapbook, showDownloadBtn } = data;

  return (
    <div className="flex w-1/2 flex-col gap-4 md:w-1/3 lg:w-1/4 xl:w-1/5">
      {imageList.map((libraryImage) => (
        <ImageLibraryResultImage
          key={libraryImage.index}
          libraryImage={libraryImage}
          onImageLoad={(e) => onImageLoad(e, libraryImage.index)}
          selected={selectedIds.includes(libraryImage.media.mediaId)}
          onSelectImage={onSelectImage}
          showSaveToScrapbook={showSaveToScrapbook}
          showDownloadBtn={showDownloadBtn}
        />
      ))}
    </div>
  );
};

export default memo(ImageLibraryResultGridColumn);
